import dynamic from "next/dynamic";
const MarqueeCardsGridComponent = dynamic(()=>import("./marquee-cards-grid-component"));
import MarqueeCardsGridConfig from "./marquee-cards-grid-config";
import MarqueeCardsGridAdvancedConfig from "./marquee-cards-grid-advanced-config";
export default {
    MarqueeCardsGridComponent,
    MarqueeCardsGridConfig,
    MarqueeCardsGridAdvancedConfig
};
